import classNames from 'classnames';

import { Box, BoxColors } from '../../Box';

import {
  SelectAllPlugin,
  FormatHeadingPlugin,
  FormatTextPlugin,
  ListAndFormatPlugin,
  LinkAndTablePlugin,
  MediaPlugin,
  UndoRedoPlugin,
  TableActionMenuPlugin,
} from './plugins';
import { Divider } from './ui';
import { WysiwygConfigType } from './WysiwygInput';

interface ToolbarPluginsProps {
  config: WysiwygConfigType;
  editable: boolean;
  loadFile: (
    file: File,
    type: 'file' | 'image',
  ) => Promise<{
    name: string;
    id: string;
    type: 'image' | 'file';
  }>;
  onUploadError: (message: string, title?: string) => void;
  bgcolor?: BoxColors;
  classes: Record<string, string>;
  floatingAnchorElem: HTMLDivElement | null;
  stickyToolbar?: boolean;
}

export const ToolbarPlugins = ({
  config,
  editable,
  loadFile,
  onUploadError,
  bgcolor,
  classes,
  floatingAnchorElem,
  stickyToolbar,
}: ToolbarPluginsProps) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      bgcolor={bgcolor}
      className={classNames({
        [classes.toolbarSticky]: stickyToolbar,
        [classes.toolbarDisabled]: !editable,
      })}
      pb="16"
    >
      <Box display="flex" alignItems="center" flexWrap="wrap">
        {config.plugins.selectAllPlugin.value && (
          <>
            <SelectAllPlugin />
            {config.plugins.selectAllPlugin.withDivider && <Divider />}
          </>
        )}

        {config.plugins.formatHeadingPlugin && (
          <>
            <FormatHeadingPlugin {...config.plugins.formatHeadingPlugin} />
            {config.plugins.formatHeadingPlugin.withDivider && <Divider />}
          </>
        )}

        {config.plugins.formatTextPlugin && (
          <>
            <FormatTextPlugin {...config.plugins.formatTextPlugin} />
            {config.plugins.formatTextPlugin.withDivider && <Divider />}
          </>
        )}

        {config.plugins.listAndFormatPlugin && (
          <>
            <ListAndFormatPlugin {...config.plugins.listAndFormatPlugin} />
            {config.plugins.listAndFormatPlugin.withDivider && <Divider />}
          </>
        )}

        {config.plugins.linkAndTablePlugin && (
          <>
            <LinkAndTablePlugin {...config.plugins.linkAndTablePlugin} />
            {floatingAnchorElem && (
              <TableActionMenuPlugin anchorElem={floatingAnchorElem} />
            )}
            {config.plugins.linkAndTablePlugin.withDivider && <Divider />}
          </>
        )}

        {config.plugins.mediaPlugin && (
          <MediaPlugin
            loadFile={loadFile}
            onUploadError={onUploadError}
            mode={config.mode}
            {...config.plugins.mediaPlugin}
          />
        )}
      </Box>

      <Box>{config.plugins.undoRedoPlugin && <UndoRedoPlugin />}</Box>
    </Box>
  );
};
